import { Modal } from '@/components/Modal'
import { Button } from '@/components/ui/button'

export interface AttachmentPreview {
  url: string
  filename: string
  mime: string
  kind: 'pdf' | 'image' | 'csv' | 'xlsx' | 'text' | 'other'
  text?: string
  loading?: boolean
}

export function AttachmentPreviewModal({
  preview,
  onClose,
}: {
  preview: AttachmentPreview | null
  onClose: () => void
}) {
  const isTextual =
    preview?.kind === 'csv' || preview?.kind === 'xlsx' || preview?.kind === 'text'
  return (
    <Modal
      open={preview !== null}
      onOpenChange={(open) => !open && onClose()}
      title={preview?.filename || 'Attachment'}
      className="max-w-5xl"
      footer={
        preview ? (
          <>
            <Button
              variant="secondary"
              onClick={() => window.open(preview.url, '_blank', 'noopener,noreferrer')}
            >
              Open in new tab
            </Button>
            <Button onClick={onClose}>Close</Button>
          </>
        ) : null
      }
    >
      {preview ? (
        preview.kind === 'pdf' ? (
          <iframe
            src={preview.url}
            title={preview.filename}
            className="h-[70vh] w-full rounded border"
          />
        ) : preview.kind === 'image' ? (
          <img
            src={preview.url}
            alt={preview.filename}
            className="max-h-[70vh] w-full object-contain"
          />
        ) : isTextual ? (
          preview.loading ? (
            <p className="text-muted-foreground">Rendering preview…</p>
          ) : preview.text ? (
            <pre className="max-h-[70vh] overflow-auto rounded border bg-muted/50 p-3 font-mono text-xs">
              {preview.text}
            </pre>
          ) : (
            <p className="text-muted-foreground">No content to preview.</p>
          )
        ) : (
          <p className="text-muted-foreground">No inline preview available for this file type.</p>
        )
      ) : null}
    </Modal>
  )
}
